import { MaybeObservable, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";
import createRequiredObservable from "flow/koHelpers/createRequiredObservable";
import { interceptAttributesWithDefaultsIgnoreId } from "flow/koHelpers/interceptAttributes";
import { selectIdAttr } from "flow/koHelpers/selectId";
import { selectLabel, selectPlaceholder } from "flow/koHelpers/selectParam";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import ko from "knockout";
import viewHtml from "./time.html";

export interface ITimeParams {
    value: KnockoutObservable<string>;
    enable?: MaybeObservable<boolean>;
    disable?: MaybeObservable<boolean>;
    attr?: MaybeObservableAttributes;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
    metaPlaceholder?: MaybeObservable<string>;
    placeholder?: MaybeObservable<string>;
}

ko.components.register("ko-time", {
    viewModel: function (params: ITimeParams) {
        this.value = params.value;
        this.required = createRequiredObservable(params.value);
        this.id = selectIdAttr("ko_time", params.attr);
        this.label = selectLabel(params.meta, params.text);
        this.enable = createEnabler(params.enable, params.disable);
        this.attributes = interceptAttributesWithDefaultsIgnoreId(
            {
                autocomplete: "off",
                placeholder: selectPlaceholder(params.metaPlaceholder, params.placeholder)
            },
            params.attr
        );
    },
    template: viewHtml,
    synchronous: true
});
